import { gql } from '@apollo/client'

export const QUERY_ACCOUNT = gql`
  query account {
    account {
      id
      featureFlips
      email
      createdAt
      isImpersonation
      products {
        name
      }
      currentOrganization {
        role
        id
        isOneBufferOrganization
        channels(product: engage) {
          name
          id
          service
          isDisconnected
          avatar
          serviceId
          organizationId
          isLocked
          apiVersion
        }
        billing {
          canAccessEngagement
          ... on OBBilling {
            canStartTrial
          }
        }
      }
    }
  }
`

export const QUERY_ENGAGE_ACCOUNT = gql`
  query engageOrganization($organizationId: String!) {
    engageOrganization(organizationId: $organizationId) {
      id
      channels {
        id
        totalComments
        totalPendingComments
        labelsCount {
          label
          count
        }
        backfillingComplete
        updatedAt
      }
      emojis
    }
  }
`

export const QUERY_USER_SETTINGS = gql`
  query engageUserSettings {
    engageUserSettings {
      showMarkAsReadWarningModal
    }
  }
`

export const MUTATE_USER_SETTINGS = gql`
  mutation engageHideMarkAsReadModal {
    engageHideMarkAsReadModal {
      code
      success
      message
    }
  }
`
